import type { CSSProperties, HTMLAttributes } from 'react';
import { cn } from '../cn';

export interface IconProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  /** Material Symbols ligature name, e.g. `arrow_back`. */
  name: string;
  /** Accessible label. When omitted the icon is decorative (`aria-hidden`). */
  label?: string;
  /** Use the filled glyph variant. */
  filled?: boolean;
}

const FILLED_STYLE: CSSProperties = { fontVariationSettings: "'FILL' 1" };

export default function Icon({
  name,
  label,
  filled = false,
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <span
      {...rest}
      className={cn('material-symbols-outlined', className)}
      style={filled ? { ...FILLED_STYLE, ...style } : style}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      {name}
    </span>
  );
}
